import React, { useEffect, useState } from "react";
import { client } from "../config/prismic";

const Details = () => {
  const [dates, setDates] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await client.getByType("dates");
      setDates(response.results[0]?.data); // Accessing the first result's data directly
    };
    fetchData();
  }, []);

  if (!dates) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }

  // Create an array of deadlines from the fetched dates
  const deadlines = [
    {
      title: "Paper Submission Start Date",
      date: dates.paper_submission[0].text,
    },
    {
      title: "Paper Submission Last Date",
      date: dates.paper_submission_end_date[0].text,
    },
    {
      title: "Acceptance Notification",
      date: dates.acceptance[0].text,
    },
    {
      title: "Camera Ready Paper",
      date: dates.camera_ready_paper[0].text,
    },
    {
      title: "Last Date for Registration",
      date: dates.last_date_registration[0].text,
    },
    {
      title: "Conference Date",
      date: dates.conference_date[0].text,
    },
  ];

  return (
    <div>
      <div className="container section-title" data-aos="fade-up">
        <h2 className="">Important Dates</h2>
        <p className=""></p>
      </div>
      <div className="serviceBoxContainer flex-c flex-wrap">
        {deadlines.map((deadline, index) => (
          <div className="serviceBox col-3 mx-5" key={index}>
            <div className="service-icon">
              <span>
                <i className="fa fa-calendar"></i>
              </span>
            </div>
            <h4 className="title">{deadline.title}</h4>
            <p className="description">{deadline.date}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Details;
